/* eslint-disable camelcase */
import axios from 'axios'
import * as POST from './getPost'

const CONVERT_DATA = (_d) => {
  return _d.data
}

const POST_REQ = async (STATE, _resolve, _path) => {
  const frequency = POST.GET_FREQUENCY_ID(STATE.questions)
  const use = POST.GET_USE_ID(STATE.questions)
  const gender = POST.GET_GENDER_ID(STATE.questions)
  const age = POST.GET_AGE_ID(STATE.questions)
  const number_people = POST.GET_NUMBER_PEOPLE_ID(STATE.questions)
  const passenger = POST.GET_PASSENGER_ID(STATE.questions)
  const body_type = POST.GET_BODY_TYPE_ID(STATE.questions)
  const maker_id = POST.GET_MAKER_ID(STATE.questions)
  const car_model_id = POST.GET_CAR_MODEL_ID(STATE.questions)
  const tire_width = POST.GET_TIRE_WIDTH_ID(STATE.questions)
  const tire_flatness = POST.GET_TIRE_FLATNESS_ID(STATE.questions)
  const tire_rim = POST.GET_TIRE_RIM_ID(STATE.questions)
  const price_performance = POST.GET_PRICE_PERFORMANCE_ID(STATE.questions)
  const needs_a = POST.GET_NEEDS_A_ID(STATE.questions)
  const needs_b = POST.GET_NEEDS_B_ID(STATE.questions)

  const SEND_DATA:any = {
    frequency,
    use,
    gender,
    age,
    number_people,
    passenger,
    body_type,
    maker_id,
    car_model_id,
    tire_width,
    tire_flatness,
    tire_rim,
    price_performance,
    needs_a,
    needs_b
  }
  const PARAMS = new URLSearchParams(SEND_DATA)
  const RESPONCE = await axios.post(_path, PARAMS).catch((e) => {
    _resolve(CONVERT_DATA(e.response))
  })
  RESPONCE && _resolve(CONVERT_DATA(RESPONCE))
}

export const getBrand = (_state, _props, _resolve, _reject) => {
  const STATE = _state
  const PATH = process.env.END_BRAND
  POST_REQ(STATE, _resolve, PATH)
}
